import { Container } from '@mui/material';
import { Routes } from 'enums';
import ErrorDialog from 'features/ui/app-layout/error-dialog';
import { useExtensionAuth } from 'hooks/use-extension-auth';
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router';
import { makeStyles } from 'tss-react/mui';
import { getPostAuthRedirectPath, getPostRegistrationRedirectPath } from 'utils/auth-redirect';

interface Props {
  authenticated: boolean;
  children?: React.ReactNode;
}

const UserLanding: React.FC<Props> = ({ authenticated, children }) => {
  const { classes } = useStyles();
  const { extensionSignInStoredValues } = useExtensionAuth();
  const location = useLocation();
  const noTopPadding = location.pathname === Routes.SIGNIN || location.pathname === Routes.SIGNUP;

  useEffect(() => {
    if (authenticated) {
      extensionSignInStoredValues();
    }
  }, [authenticated]);

  return (
    <>
      {authenticated ? (
        // Honour a destination carried through the login rather than always landing on the
        // chat: someone who followed a link here was on their way somewhere specific.
        // Exception: right after a registration the setup wizard (in the chat) comes first.
        <Navigate
          to={location.pathname === Routes.SIGNUP ? getPostRegistrationRedirectPath() : getPostAuthRedirectPath(location, Routes.AI_CHAT)}
          replace={true}
        />
      ) : (
        <Container className={classes.landing} style={{ maxWidth: '1920px', paddingTop: noTopPadding ? 0 : undefined }}>
          {children}
        </Container>
      )}
      <ErrorDialog />
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  landing: {
    paddingTop: '48px',
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
}));

export default UserLanding;
